import * as t from "io-ts";

export type KlassOutput = string & {
  readonly KlassOutputId: unique symbol;
};

export const klassOutputC = new t.Type<KlassOutput, KlassOutput, unknown>(
  "KlassOutput",
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  t.string.is as t.Is<KlassOutput>,
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  t.string.validate as t.Validate<unknown, KlassOutput>,
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  t.string.encode as unknown as t.Encode<KlassOutput, KlassOutput>,
);
